/**
 * A SEMANA DA PREMIAÇÃO na tela — cópia de packages/domain/src/premiacao/semana.ts (a web não
 * importa o domain). Sexta a quinta até 15/10/2026; transição de 16/10 a 23/10 (8 dias); SÁBADO
 * a SEXTA desde 24/10/2026 (dono, 23/10/2026). Mudou lá, muda aqui.
 */

const TRANSICAO_DE = '2026-10-16';
const TRANSICAO_ATE = '2026-10-23';

const mais = (d: string, n: number) =>
  new Date(Date.parse(`${d}T12:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);

/** O dia que abre a semana do `dia`. */
export function inicioDaSemana(dia: string): string {
  if (dia >= TRANSICAO_DE && dia <= TRANSICAO_ATE) return TRANSICAO_DE;
  const dow = new Date(`${dia}T12:00:00Z`).getUTCDay();
  return mais(dia, -(dia > TRANSICAO_ATE ? (dow + 1) % 7 : (dow + 2) % 7));
}

/** A semana inteira do `dia` (de → ate). */
export function semanaDoDia(dia: string): { de: string; ate: string } {
  const de = inicioDaSemana(dia);
  return { de, ate: de === TRANSICAO_DE ? TRANSICAO_ATE : mais(de, 6) };
}

/** Como a semana se chama: "sábado a sexta", "sexta a quinta" (as antigas) ou a de transição. */
export function nomeDaSemana(p: { de: string }): string {
  if (p.de === TRANSICAO_DE) return 'sexta a sexta (transição)';
  return p.de > TRANSICAO_ATE ? 'sábado a sexta' : 'sexta a quinta';
}

/** A semana anterior à do `dia`. */
export function semanaAnterior(dia: string): { de: string; ate: string } {
  return semanaDoDia(mais(inicioDaSemana(dia), -1));
}
